import React from 'react';
import { getDefault } from 'modules/shared-cms/utils';
import { getNestedReferenceId } from 'modules/shared-cms-advanced/utils';

import { Promo, Carrousel, Introduction, Tendance } from 'modules/shared-cms-advanced/enhanced-blocs';

import { HomeProps } from './home-type';
import enhancer from './home-enhancer';

const InnerHomePage: React.FC<HomeProps> = React.memo(({ intro, carrousel, tendance, promo }: HomeProps) => {
    const {
        introId = getDefault(getNestedReferenceId(intro), ''),
        carrouselId = getDefault(getNestedReferenceId(carrousel), ''),
        tendanceId = getDefault(getNestedReferenceId(tendance), ''),
        promoId = getDefault(getNestedReferenceId(promo), ''),
    } = {};

    return (
        <React.Fragment>
            {introId ? <Introduction id={introId} /> : ''}

            {carrouselId ? <Carrousel id={carrouselId} /> : ''}

            {tendanceId ? <Tendance id={tendanceId} /> : ''}

            {promoId ? <Promo id={promoId} /> : ''}
        </React.Fragment>
    );
});

export const HomePage = enhancer(InnerHomePage);
